import React from "react";

const ImageStack = ({ images }) => {
  return (
    <div style={{ position: "relative", width: "100%" }}>
      {images.map((src, index) =>
        src ? (
          <img
            key={index}
            src={src}
            style={{
              width: "100%",
              objectFit: "contain",
              position: "absolute",
              zIndex: index + 1, // Set the z-index based on the order in the array
            }}
            alt="IMG"
          />
        ) : null
      )}
    </div>
  );
};

export default ImageStack;
